/* @ngInject */

export default (
  $rootScope,
  $scope,
  $stateParams,
  $state,
  $timeout,
  $mdDialog,
  webpage,
  eventService,
  boardService,
  filtersService,
  workflowsService,
  ticketService,
  ticketsService,
  accountsService,
  jobsService,
  jobTypesService,
  notesService,
  labelsService,
  privilegeService,
  partnersService,
  Color,
  NOTE,
  TICKET,
  ACCOUNT,
  PARTNER
) => {
  /*
   * Controller Model
   * --------------------------------------------------------------------------------
   */
  $scope.Model = {
    workflowsData: {
      available: [],
      current: null
    },
    stagesData: {
      available: [],
      model: {
        id: '',
        count: 0,
        total: 0,
        isLoading: false,
        hasMore: true
      }
    },
    ticketsData: {
      accounts: [],
      contacts: [],
      partners: []
    },
    accountsData: {
      available: []
    },
    labelsData: {
      available: []
    },
    partnersData: {
      available: []
    },
    jobTypesData: {
      available: []
    },
    filtersData: {
      available: [],
      current: null,
      isReady: false
    },
    boardHeight: null,
    availableTileColors: _.filter(
      Color.available(),
      (c) => c.name.includes('100') || c.name === 'white'
    ),
    availableTileActions: [
      'add_note',
      'add_job',
      'select_labels',
      'move_to_another_workflow',
      'email_to_notes',
      'set_tile_color'
    ],
    ticketSortingOptions: {
      active: {},
      enabled: {
        placeholder: 'drag-place-holder',
        connectWith: 'board stage main',
        cursor: 'move',
        opacity: 0.65,
        start(e, ui) {
          ui.item.show().addClass('ghost');
        },
        helper(event, element) {
          return $(element).clone().addClass('dragging');
        },
        update(event, ui) {
          if (
            !ui.item.sortable.received &&
            ui.item.sortable.source[0] === ui.item.sortable.droptarget[0]
          ) {
            ui.item.sortable.cancel();
          }
        },
        stop(e, ui) {
          ui.item.show().removeClass('ghost');
          boardService
            .ticketMove(
              e,
              ui,
              $scope.Model.workflowsData.current,
              $scope.Model.ticketsData.contacts
            )
            .then(() => {
              $scope.boardHasChanges();
            });
        }
      },
      disabled: {
        connectWith: 'board',
        start() {},
        helper() {},
        update() {},
        stop() {}
      },
      property: 'timeStamp',
      descending: true
    },
    currentCurrency: $rootScope.CurrentCurrency(),
    isLoading: false,
    isReady: false
  };

  /*
   * Controller Public Functions: Board
   * --------------------------------------------------------------------------------
   */
  $scope.boardHasChanges = () => ticketsService.clearCache();
  $scope.isTicketEditAllowed = () => privilegeService.isTicketEditAllowed();
  $scope.isTicketMoveAllowed = () => privilegeService.isTicketMoveAllowed();
  $scope.workflowSum = () =>
    _.reduce($scope.Model.stagesData.available, (m, n) => m + parseInt(n.sum, 10), 0) || 0;
  $scope.workflowTotal = () =>
    _.reduce($scope.Model.stagesData.available, (m, n) => m + parseInt(n.total, 10), 0) || 0;
  $scope.stageSum = (idStage) => {
    const stage = _.find($scope.Model.stagesData.available, (s) => s.id === idStage);
    return stage.sum || 0;
  };
  $scope.stageTotal = (idStage) => {
    const stage = _.find($scope.Model.stagesData.available, (s) => s.id === idStage);
    return stage.total || 0;
  };
  $scope.stageCollapse = (stage) =>
    boardService.stageCollapse($scope.Model.workflowsData.current, stage);
  $scope.ticketsModifyOrder = (isDescending, orderBy) => {
    if (isDescending === true || isDescending === false) {
      $scope.Model.ticketSortingOptions.isDescending = isDescending;
    }
    if (orderBy) {
      $scope.Model.ticketSortingOptions.property = orderBy;
    }
    $scope.filterApply();
  };
  $scope.ticketMoveToAnotherWorkflow = ($event, ticketToMove) => {
    const ticket = {
      id: ticketToMove.id,
      idWorkflow: ticketToMove.idWorkflow,
      idStage: ticketToMove.idStage,
      idOwner: ticketToMove.idOwner,
      name: ticketToMove.name
    };
    $event.stopPropagation();
    ticketService
      .ticketMoveToAnotherWorkflow({
        event: $event,
        ticket,
        workflow: $scope.Model.workflowsData.current,
        workflows: $scope.Model.workflowsData.available,
        accounts: $scope.Model.accountsData.available
      })
      .then((result) => {
        $scope.boardHasChanges();
        $timeout(() => {
          $state.transitionTo('board', {
            id: result.idWorkflow
          });
        }, 1000);
      });
  };
  $scope.ticketsHasMoreToLoad = (idStage) => {
    const stage = _.find($scope.Model.stagesData.available, (s) => s.id === idStage);
    return stage && stage.isLoading === false && stage.hasMore === true;
  };
  $scope.ticketsLoadMore = (idStage) => {
    boardService
      .ticketsLoad(
        $scope.Model.workflowsData,
        $scope.Model.stagesData,
        $scope.Model.ticketsData,
        $scope.Model.ticketSortingOptions,
        $scope.Model.filtersData,
        false,
        idStage
      )
      .then(() => {
        $scope.Model.boardHeight = boardService.boardHeight(
          $scope.Model.workflowsData.current,
          $scope.Model.stagesData,
          $rootScope.CurrentAccount
        );
      });
  };

  /*
   * Controller Public Functions: Filters
   * --------------------------------------------------------------------------------
   */
  $scope.filterApply = (idFilter, filterName) => {
    $scope.boardHasChanges();
    $scope.filtersClose();
    $scope.Model.filtersData.current = null;
    if (idFilter && filterName) {
      $scope.Model.filtersData.current = { id: idFilter, name: filterName };
      boardService.cookieFilterSet(
        $scope.Model.workflowsData.current.id,
        $scope.Model.filtersData.current.id
      );
    } else {
      boardService.cookieFilterRemove($scope.Model.workflowsData.current.id);
    }

    $scope.Model.isReady = false;
    boardService
      .ticketsLoad(
        $scope.Model.workflowsData,
        $scope.Model.stagesData,
        $scope.Model.ticketsData,
        $scope.Model.ticketSortingOptions,
        $scope.Model.filtersData,
        true
      )
      .then((res) => {
        $timeout(() => {
          $scope.Model.boardHeight = boardService.boardHeight(
            $scope.Model.workflowsData.current,
            $scope.Model.stagesData,
            $rootScope.CurrentAccount
          );
          $scope.Model.isReady = res;
        });
      });
  };
  $scope.filtersOpen = () => {
    $timeout(() => {
      $scope.Model.filtersData.isReady = true;
    });
  };
  $scope.filtersClose = () => {
    filtersService.clearCache();
    filtersService.getAvailable({ type: 'ticket', isActive: true }).then((filters) => {
      $scope.Model.filtersData.available = filters;
    });
    $timeout(() => {
      $scope.Model.filtersData.isReady = false;
    });
  };

  /*
   * Controller Functions: Jobs
   * --------------------------------------------------------------------------------
   */
  $scope.jobAdd = ($event, job, ticket) => {
    eventService.jobEdit({
      event: $event,
      job,
      isJob: true,
      showAccounts: true,
      showTicket: true,
      isTasksPage: false,
      stage: null,
      jobTypes: $scope.Model.jobTypesData.available,
      accounts: $scope.Model.accountsData.available,
      workflow: $scope.Model.workflowsData.current,
      ticket
    });
  };
  $scope.jobAdded = () => {
    jobsService.clearCache();
  };

  /*
   * Controller Functions: Notes
   * --------------------------------------------------------------------------------
   */
  $scope.noteAdd = ($event, note, ticket) => {
    eventService.noteEdit({
      event: $event,
      note,
      list: null,
      url: NOTE.API.UPLOAD,
      ticket,
      title: 'Drag & Drop file(s) here, or click to browse',
      allowedMimeTypes: '',
      allowedExtensions: ''
    });
  };
  $scope.noteAdded = () => {
    notesService.clearCache();
  };

  /*
   * Controller Functions: Labels
   * --------------------------------------------------------------------------------
   */
  $scope.labelSelect = ($event, ticket) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.labelsData.available,
      selectedLabels: ticket.idLabels,
      data: ticket
    });
  };
  $scope.labelSelected = (selectedLabels, data) => {
    $scope.boardHasChanges();
    boardService.ticketUpdateLabels($scope.Model.workflowsData.current, data, selectedLabels);
  };

  /*
   * Run Controller
   * --------------------------------------------------------------------------------
   */
  const init = () => {
    webpage.pageTitle('Loading, please wait');

    workflowsService.getAvailable({ isActive: true }).then((workflows) => {
      eventService.onWorkflowTicketMove((eventPayload) => {
        boardService.ticketMoved($scope.Model.workflowsData.current, eventPayload);
      });
      $scope.Model.workflowsData.available = workflows;
      $scope.Model.workflowsData.current = _.find(
        $scope.Model.workflowsData.available,
        (wf) => wf.id === $stateParams.id
      );
      _.forEach($scope.Model.workflowsData.current.stages, (stage) => {
        const stageModel = angular.copy($scope.Model.stagesData.model);
        stageModel.id = stage.id;
        $scope.Model.stagesData.available.push(stageModel);
      });
      webpage.pageTitle($scope.Model.workflowsData.current.name);

      filtersService.getAvailable({ type: 'ticket', isActive: true }).then((filters) => {
        $scope.Model.filtersData.available = filters;
        const filter = boardService.cookieFilter(
          $scope.Model.workflowsData.current.id,
          $scope.Model.filtersData.available
        );
        $scope.filterApply(filter ? filter.id : null, filter ? filter.name : null);
      });

      labelsService
        .getAvailable({
          type: 'ticket',
          orderBy: 'name',
          coerceTo: 'string',
          isDescending: false,
          isActive: true
        })
        .then((labels) => {
          $scope.Model.labelsData.available = labels;
        });

      jobTypesService.getAvailable({ isActive: true }).then((jobTypes) => {
        $scope.Model.jobTypesData.available = jobTypes;
      });

      const idAccounts = $scope.Model.workflowsData.current.idTeamMembers.concat(
        $scope.Model.workflowsData.current.idOwner
      );
      accountsService
        .getSpecific({
          ids: idAccounts,
          fields: ACCOUNT.FIELDS.LIST,
          isActive: true
        })
        .then((accounts) => {
          $scope.Model.accountsData.available = accounts;
        });

      partnersService
        .getAvailable({ isActive: true, fields: PARTNER.FIELDS.CHIPS })
        .then((partners) => {
          $scope.Model.partnersData.available = partners;
        });
    });
  };

  init();
};
